// gkc_hash_code : 01GPFQ2BY4JCG0W281FKCRX39R
import styles from './EDIConfirmModal.module.scss';
import { Modal } from 'components/atoms/Modal';
import React from 'react';
import { IconClose } from 'components/atoms/icons/IconClose';
import { useTranslation } from 'react-i18next';
import { mergeClasses } from 'util/commons';

interface Props {
  onClose: () => void;
  onHandleSubmit: () => void;
  contactName?: string;
  isDarkMode?: boolean;
}

const EDIConfirmModal: React.FC<Props> = ({
  onClose,
  onHandleSubmit,
  contactName,
  isDarkMode,
}) => {
  const { t } = useTranslation();

  return (
    <div
      className={mergeClasses(styles.customModal, {
        [styles.customModalDarkMode]: isDarkMode,
      })}
    >
      <Modal>
        <div className={styles.confirmEDIModal}>
          <div className={styles.customTitle}>
            <div className={styles.title}>
              {t('confirm_edi_modal.confirm_title')}
            </div>
            <div className={styles.customIcon}>
              <div className={styles.top}>
                <IconClose onClick={onClose} />
              </div>
            </div>
          </div>

          <div className={styles.customDescription}>
            <p className={styles.msg}>
              {t('confirm_edi_modal.contact_name_edi_note', {
                value: contactName,
              })}
            </p>
          </div>

          <div className={styles.submit}>
            <button
              className={styles.submitButton}
              type="submit"
              onClick={onHandleSubmit}
            >
              {t('confirm_edi_modal.register_button')}
            </button>
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default EDIConfirmModal;
